import React from "react"
import { makeStyles } from "@material-ui/core/styles"

import Card from "@material-ui/core/Card"
// import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import Button from "./Button"

const useStyles = makeStyles((theme) => ({
  card: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 345,
  },
}))

const AssociationCard = ({ association, onClick }) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      {/* <CardActionArea> */}
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          {association.name}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          Unit: {association.unit}, Role: {association.role}
        </Typography>
      </CardContent>
      <CardActions>
        <Button endIcon={<ChevronRightIcon />} onClick={onClick} variant="text">
          Sign In
        </Button>
      </CardActions>
      {/* </CardActionArea> */}
    </Card>
  )
}

export default AssociationCard
